export default "__VITE_ASSET__DPvdtuIA__"